import React from 'react';
import { ClientInvoicesList } from '../../../../../shared/ClientInvoices';
import { ActionButtonLayout } from '../../../../../v2BaseComponents/ActionButtonLayout';
import { View } from 'react-native';
import { mainContentPadding } from '../../../../../v2BaseComponents/MainContentContainer';

export type ClientRecordInvoicesOwnProps = {
    clientRecordId: string;
};

export type ClientRecordInvoicesProps = ClientRecordInvoicesOwnProps;

const ClientRecordInvoices: React.FC<ClientRecordInvoicesProps> = ({ clientRecordId }) => {
    return (
        <ActionButtonLayout scrollable restrictedWidthVariant="lg">
            <View style={{ flex: 1, paddingTop: mainContentPadding }}>
                <ClientInvoicesList clientRecordId={clientRecordId} />
            </View>
        </ActionButtonLayout>
    );
};

export default React.memo(ClientRecordInvoices);
